import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CategoryAvailableReservations } from 'projects/qcloud-models/reservation-plugin/category-available-reservations';
import { TicketReservationPlugin } from 'projects/qcloud-models/reservation-plugin/ticket-reservation-plugin';
import { Subscription, timer, Subject } from 'rxjs';
import { ReservationPluginService } from '../../../services/reservation-plugin.service';
import { TicketReservationService } from '../../../services/ticket-reservation.service';
import { TimeService } from '../../../services/time.service';

@Component({
  selector: 'app-reservation-times',
  templateUrl: './reservation-times.component.html',
  styleUrls: ['./reservation-times.component.scss']
})
export class ReservationTimesComponent implements OnInit, OnDestroy {

  @Input() availableTimes: Map<number, CategoryAvailableReservations>;
  @Input() setZeroTimer: Subject<boolean>;
  ticketReservation = new TicketReservationPlugin();
  availableReservationIdx: number;
  categoryAvailableReservations: CategoryAvailableReservations;
  previousDate = new Date();
  readonly bookedReservationTime: number = 120000;
  bookedReservationCounter: number;
  bookedReservationCountDown: Subscription;
  reservedCategoryCapacity: number;

  constructor(private ticketReservationService: TicketReservationService, private timeService: TimeService,
    private service: ReservationPluginService, private toastr: ToastrService, private translate: TranslateService) {
    ticketReservationService.ticketReservation.subscribe((val: TicketReservationPlugin) => {
      this.ticketReservation = val;
      if (!this.timeService.sameDay(this.previousDate, new Date(this.ticketReservation.reservationTime))) {
        this.availableReservationIdx = -1;
      }
      this.previousDate = new Date(val.reservationTime);
      this.getAvailableReservationTimes();
    });
  }

  ngOnInit(): void {
    this.setZeroTimer.subscribe(v => {
      this.bookedReservationCounter = 1000;
      let lastReservationTime = new Date(this.ticketReservation.reservationTime);
      this.unbookPreviousReservation(lastReservationTime);
    });
  }

  getAvailableReservationTimes() {
    this.categoryAvailableReservations = new CategoryAvailableReservations();
    if (this.ticketReservation.categoryId && this.ticketReservation.reservationTime) {
      this.categoryAvailableReservations.availableReservations = this.availableTimes[this.ticketReservation.categoryId]
        .availableReservations;
      this.categoryAvailableReservations.availableReservations =
        this.categoryAvailableReservations.availableReservations.filter(
          x => this.timeService.sameDay(new Date(x.reservationTime), new Date(this.ticketReservation.reservationTime)));
    }
  }

  selectReservationTime(reservationTimeIdx: number) {
    let lastReservationTime = new Date(this.ticketReservation.reservationTime);
    let reservationTime = new Date(this.categoryAvailableReservations.availableReservations[reservationTimeIdx].reservationTime + "Z");
    this.ticketReservation.reservationTime.setHours(reservationTime.getHours());
    this.ticketReservation.reservationTime.setMinutes(reservationTime.getMinutes());
    this.ticketReservation.isTimeSelected = true;
    this.service.bookReservationTime(this.ticketReservation).subscribe(
      reservedCategoryCapacity => {
        if (reservedCategoryCapacity != -1) {
          this.handleBookTimeSuccess(reservationTimeIdx, reservedCategoryCapacity, lastReservationTime);
        }
        else {
          this.handleBookTimeError(lastReservationTime);
        }
      },
      err => {
        this.handleBookTimeError(lastReservationTime);
      }
    );
  }

  handleBookTimeSuccess(reservationTimeIdx: number, reservedCategoryCapacity: number, lastReservationTime: Date) {
    this.unbookPreviousReservation(lastReservationTime);
    this.reservedCategoryCapacity = reservedCategoryCapacity;
    this.bookedReservationCounter = this.bookedReservationTime;
    if (!this.bookedReservationCountDown || this.bookedReservationCountDown.closed) {
      this.setupTimer();
    }

    this.availableReservationIdx = reservationTimeIdx;
    this.ticketReservationService.updateTicketReservation(this.ticketReservation);
  }

  unbookPreviousReservation(lastReservationTime: Date) {
    if (this.availableReservationIdx != -1) {
      let unbookTicketReservation = new TicketReservationPlugin();
      unbookTicketReservation.categoryId = this.ticketReservation.categoryId;
      unbookTicketReservation.reservationTime = lastReservationTime;
      this.service.unbookReservationTime(unbookTicketReservation, this.reservedCategoryCapacity)
        .subscribe(res => { });
    }
  }

  handleBookTimeError(lastReservationTime: Date) {
    this.ticketReservation.reservationTime = lastReservationTime;
    this.translate.get('choose-time-error').subscribe((error: string) => {
      this.translate.get('choose-different-time').subscribe((res: string) => {
        this.toastr.info(res, error);
      });
    });
  }

  setupTimer() {
    this.bookedReservationCountDown = timer(0, 1000)
      .subscribe(() => {
        this.bookedReservationCounter -= 1000;
        if (this.bookedReservationCounter <= 0) {
          this.bookedReservationCountDown.unsubscribe();
        }
      });
  }

  ngOnDestroy(): void {
    if (this.bookedReservationCountDown) {
      this.bookedReservationCountDown.unsubscribe();
    }
  }

  checkIfAnyReservationAvailable() {
    return this.categoryAvailableReservations.availableReservations.length > 0;
  }

}
